export enum CALENDAR_TYPE {
  FILTER = "filter",
  NATIVE = "native",
  GOOGLE = "google",
  OUTLOOK = "outlook",
  ICLOUD = "icloud",
}

export enum CALENDAR_TYPES_EXTERNAL {
  GOOGLE = CALENDAR_TYPE.GOOGLE,
  OUTLOOK = CALENDAR_TYPE.OUTLOOK,
  ICLOUD = CALENDAR_TYPE.ICLOUD,
}

export enum CALENDAR_NOTIFICATION_ADVICE_TYPE {
  PUSH = "push",
  EMAIL = "email",
}

export enum CALENDAR_NOTIFICATION_ADVIDE_UNIT_TIME {
  MINUTES = "minutes",
  HOURS = "hours",
  DAYS = "days",
}
